import { render } from "./RecursoCangrejo.vue?vue&type=template&id=6eb319f8&scoped=true"
import script from "./RecursoCangrejo.vue?vue&type=script&lang=js"
export * from "./RecursoCangrejo.vue?vue&type=script&lang=js"

import "./RecursoCangrejo.vue?vue&type=style&index=0&id=6eb319f8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6eb319f8"]])

export default __exports__